module.exports = __webpack_public_path__ + "img/IMAGE_BSD_DESERT.fe63c247.webp";